export default __webpack_public_path__ + "static/management-a5daccacd210e4a90b254e14cdfe44ca.svg";